"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UDP_HANDOVER_PORT_RANGE_END = exports.UDP_HANDOVER_PORT_RANGE_START = exports.UDP_TUNNEL_PORT_RANGE_END = exports.UDP_TUNNEL_PORT_RANGE_START = exports.TCP_THUMB_EDGE_CONTROL_HTTP_PORT = exports.TCP_EDGE_CONTROL_HTTP_PORT = void 0;
exports.isIpBasedProtocol = isIpBasedProtocol;
exports.isUdpBasedProtocol = isUdpBasedProtocol;
exports.isTcpBasedProtocol = isTcpBasedProtocol;
exports.getLocalPortFromPortDbConfiguration = getLocalPortFromPortDbConfiguration;
exports.getLocalPortNumbersUsedByInputPort = getLocalPortNumbersUsedByInputPort;
exports.getLocalPortNumbersUsedByOutputPort = getLocalPortNumbersUsedByOutputPort;
exports.getLocalPortNumbersUsedByInputProtocol = getLocalPortNumbersUsedByInputProtocol;
exports.getLocalPortNumbersUsedByOutputProtocol = getLocalPortNumbersUsedByOutputProtocol;
exports.physicalPortTypeMatchesPortMode = physicalPortTypeMatchesPortMode;
const helpers_1 = require("./api/v1/helpers");
const types_1 = require("./api/v1/types");
exports.TCP_EDGE_CONTROL_HTTP_PORT = 8081;
// TODO: We don't check for conflicts on the thumb port to be backwards compatible with potentially existing services.
// This could cause issues if the thumb appliance is located on the video node.
exports.TCP_THUMB_EDGE_CONTROL_HTTP_PORT = 8082;
// TODO: EDGE-4269: Use GlobalSettings.ristTunnelBasePort instead of UDP_TUNNEL_PORT_RANGE_START when checking for reserved ports.
exports.UDP_TUNNEL_PORT_RANGE_START = 20000;
exports.UDP_TUNNEL_PORT_RANGE_END = 20999;
exports.UDP_HANDOVER_PORT_RANGE_START = 30000;
exports.UDP_HANDOVER_PORT_RANGE_END = 30999;
function isIpBasedProtocol(mode) {
    return mode in types_1.IpPortMode;
}
function isUdpBasedProtocol(mode) {
    return isIpBasedProtocol(mode) && !isTcpBasedProtocol(mode);
}
function isTcpBasedProtocol(mode) {
    return mode === types_1.IpPortMode.rtmp;
}
function getLocalPortFromPortDbConfiguration(configuration) {
    // Rendezvous 'remotePort' is also the local listen port
    if ('remotePort' in configuration && 'srtMode' in configuration && configuration.srtMode === types_1.SrtMode.rendezvous)
        return configuration.remotePort;
    if ('localPort' in configuration && configuration.localPort)
        return configuration.localPort;
    return 0;
}
function getLocalPortNumbersUsedByInputPort(port) {
    let localBasePort = undefined;
    switch (port.mode) {
        case types_1.IpPortMode.generator:
            if (typeof port.port === 'number') {
                localBasePort = port.port;
            }
            break;
        case types_1.IpPortMode.udp: // fallthrough
        case types_1.IpPortMode.rtp: // fallthrough
        case types_1.IpPortMode.rist: // fallthrough
        case types_1.IpPortMode.rtmp:
            localBasePort = port.port;
            break;
        case types_1.IpPortMode.srt: {
            switch (port.srtMode) {
                case types_1.SrtMode.rendezvous:
                    localBasePort = port.remotePort;
                    break;
                case types_1.SrtMode.caller: // fallthrough
                case types_1.SrtMode.listener:
                    localBasePort = port.localPort;
                    break;
            }
            break;
        }
    }
    return localBasePort
        ? getLocalPortNumbersUsedByInputProtocol({
            mode: port.mode,
            localBasePort,
            isFec: 'fec' in port && !!port.fec,
            isRtcp: port.mode === types_1.IpPortMode.rtp && port.rtcp === true,
            isMulticast: 'multicastAddress' in port && !!port.multicastAddress,
        })
        : [];
}
function getLocalPortNumbersUsedByOutputPort(port) {
    let localBasePort = undefined;
    switch (port.mode) {
        case types_1.IpPortMode.rtp: // fallthrough
        case types_1.IpPortMode.udp: // fallthrough
        case types_1.IpPortMode.rist: // fallthrough
            localBasePort = port.localPort;
            break;
        case types_1.IpPortMode.srt: {
            switch (port.srtMode) {
                case types_1.SrtMode.rendezvous:
                    localBasePort = port.remotePort;
                    break;
                case types_1.SrtMode.caller: // fallthrough
                case types_1.SrtMode.listener:
                    localBasePort = port.localPort;
                    break;
            }
            break;
        }
    }
    return localBasePort
        ? getLocalPortNumbersUsedByOutputProtocol({
            mode: port.mode,
            localBasePort,
        })
        : [];
}
function getLocalPortNumbersUsedByInputProtocol(port) {
    const portNumbers = new Set();
    switch (port.mode) {
        case types_1.IpPortMode.rist:
            portNumbers.add(port.localBasePort);
            portNumbers.add(port.localBasePort + 1); // RTCP
            break;
        case types_1.IpPortMode.udp:
            // EDGE-4003: Don't check for conflicts against multicast ports
            if (!port.isMulticast) {
                portNumbers.add(port.localBasePort);
            }
            break;
        case types_1.IpPortMode.rtp:
            // EDGE-4003: Don't check for conflicts against multicast ports
            if (!port.isMulticast) {
                portNumbers.add(port.localBasePort);
                if (port.isRtcp) {
                    portNumbers.add(port.localBasePort + 1);
                }
                if (port.isFec) {
                    portNumbers.add(port.localBasePort + 2);
                    portNumbers.add(port.localBasePort + 4);
                }
            }
            break;
        case types_1.IpPortMode.rtmp: // fallthrough
        case types_1.IpPortMode.srt: // fallthrough
        case types_1.IpPortMode.generator:
            portNumbers.add(port.localBasePort);
            break;
    }
    return Array.from(portNumbers);
}
function getLocalPortNumbersUsedByOutputProtocol(port) {
    const portNumbers = new Set();
    switch (port.mode) {
        case types_1.IpPortMode.udp: // fallthrough
        case types_1.IpPortMode.rtp: // fallthrough
        case types_1.IpPortMode.srt: // fallthrough
        case types_1.IpPortMode.rist:
            portNumbers.add(port.localBasePort);
            break;
    }
    return Array.from(portNumbers);
}
function physicalPortTypeMatchesPortMode(physicalPortType, mode) {
    switch (physicalPortType) {
        case types_1.PortType.coax:
            return mode in types_1.CoaxPortMode || mode in types_1.MatroxPortMode || mode === types_1.ComprimatoPortMode.comprimatoSdi;
        case types_1.PortType.ndi:
            return mode === types_1.ComprimatoPortMode.comprimatoNdi;
        case types_1.PortType.videon:
            return mode in types_1.VideonPortMode;
        case types_1.PortType.ip: {
            return (0, helpers_1.isIpPortMode)(mode);
        }
    }
}
//# sourceMappingURL=data:application/json;base64,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